/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string;
  idLeadCorretor: string;
}
export function useGetDadosDaUnidade(props: Props) {
  const GET_DADOS_UNIDADE = `${backofficeEnviroment}/common/oportunidades-lead/dados-unidade/vivaz/v1/${props.idUnidade}/${props.idLeadCorretor}`;
  const fetchData = async () => {
    const response = await instance.get(GET_DADOS_UNIDADE);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["get-dados-unidade"],
    refetchOnWindowFocus: false,
  });
  return query;
}
